/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ presence: "false" | "true" }} PresenceInputs */



/**
* | presence | output |
* | --- | --- |
* | "false" | "Presence not detected" |
* | "true" | "Presence detected" |
*
* @param {PresenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const presence = /** @type {((inputs: PresenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PresenceInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.presence === "false") return /** @type {LocalizedString} */ (`Presence not detected`);
		if (i?.presence === "true") return /** @type {LocalizedString} */ (`Presence detected`);
		return /** @type {LocalizedString} */ ("presence");
	}
	{
		if (i?.presence === "false") return /** @type {LocalizedString} */ (`Présence non détectée`);
		if (i?.presence === "true") return /** @type {LocalizedString} */ (`Présence détectée`);
		return /** @type {LocalizedString} */ ("presence");
	}
});